import { createRouter, createWebHistory } from 'vue-router';
import { useLoadingStore } from '@swpsoftware/commons-vue';

const getPageRoute = (path: string, page: string, extra = {}) => ({
  path,
  name: page,
  component: () => import(`@/views/${page}.vue`),
  ...extra,
});

const routes = [
  {
    // TODO: remove this redirect
    path: '/',
    redirect: '/projects',
  },
  getPageRoute('/projects', 'ProjectTreeView'),
  getPageRoute('/project/:projectId', 'SelectTemplateForProjectView'),
  getPageRoute('/project/:projectId/:templateId', 'ProjectView'),

  getPageRoute('/templates/:templateId', 'TemplateView', { props: { isCommonCollection: false } }),
  getPageRoute('/templates/:templateId/preview/:projectId', 'TemplatePreviewView', {
    props: { isCommonCollection: false },
  }),
  getPageRoute('/templates', 'TemplateTreeView', { props: { isCommonCollection: false } }),
  getPageRoute('/templates/:templateId/read', 'TemplateReadView'),

  getPageRoute('/common-templates/:templateId', 'TemplateView', {
    name: 'CommonTemplateView',
    props: { isCommonCollection: true },
  }),
  getPageRoute('/common-templates/:templateId/preview/:projectId', 'TemplatePreviewView', {
    name: 'CommonTemplatePreviewView',
    props: { isCommonCollection: true },
  }),
  getPageRoute('/common-templates', 'TemplateTreeView', {
    name: 'CommonTemplateTreeView',
    props: { isCommonCollection: true },
  }),
  getPageRoute('/company-texts', 'CompanyTextsView'),
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.afterEach(async () => {
  useLoadingStore().resetError();
});

export default router;
